<h2 mat-dialog-title>{{ 'BUSINESS_PROFILE.LEARN_MORE.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p class="subtitle">
    {{ 'BUSINESS_PROFILE.LEARN_MORE.WHAT_INFORMATION_QUESTION' | translate }}
  </p>
  <div class="learn-content">
    <span>{{ 'BUSINESS_PROFILE.LEARN_MORE.WHAT_INFORMATION' | translate }}</span>
    <ul>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.BUSINESS_NAME' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.ADDRESS_SERVICE_AREAS' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.WEBSITE' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.PHONE_NUMBER' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.CATEGORIES' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.HOURS' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.SERVICES_OFFERED' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.SHORT_DESCRIPTION' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.LONG_DESCRIPTION' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.SOCIAL_MEDIA_URLS' | translate }}</li>
      <li>{{ 'BUSINESS_PROFILE.LEARN_MORE.BOOKING_URL' | translate }}</li>
    </ul>
  </div>

  <div *ngIf="!data?.readOnly">
    <ai-knowledge-apps-for-knowledge-source
      [knowledgeSourceId]="knowledgeSourceId()"
    ></ai-knowledge-apps-for-knowledge-source>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <a
    mat-stroked-button
    color="secondary"
    class="manage-business-profile"
    [routerLink]="businessProfileUrl()"
    target="_blank"
  >
    {{ 'BUSINESS_PROFILE.MANAGE_BUSINESS_PROFILE' | translate }}
    <mat-icon iconPositionEnd>open_in_new</mat-icon>
  </a>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
</mat-dialog-actions>
